import { useQuery } from 'react-query';
import { IPaginationParams } from '../../../../types';
import { ISportUnityFilterParams, ISportUnityGetParams } from '../../types';
import {
  getSportUnitiesByLicenseAsync,
  getSportUnitiesByLicenseCountAsync,
} from '../../index';
import { getUserId } from '../../../../DefaultService';

const USER_ID = getUserId();

export const useGetAllSportUnitiesByLicenseAsync = ({
  pagination,
  filter,
}: ISportUnityGetParams) =>
  useQuery([`sportUnities${pagination?.pageNumber}`, pagination, USER_ID], {
    keepPreviousData: true,
    staleTime: 1000 * 60,
    queryFn: () => getSportUnitiesByLicenseAsync({ pagination, filter }),
  });

export const useGetAllSportUnitiesByLicenseCountAsync = (
  pagination?: IPaginationParams,
  filter?: ISportUnityFilterParams,
) =>
  useQuery(
    [`sportUnitiesCount${pagination?.pageNumber}`, pagination, USER_ID],
    {
      keepPreviousData: true,
      staleTime: 1000 * 60,
      queryFn: () => getSportUnitiesByLicenseCountAsync(filter),
    },
  );
